import Auth from "@aws-amplify/auth";

export async function Init(): Promise<void> {
  const config = {
    stage: "gamma",
    aws_cognito_region: "ap-southeast-2",
    aws_cognito_identity_pool_id: "ap-southeast-2:eed41b1f-640b-467a-bdd8-ac1345918c78",
    aws_user_pools_id: "ap-southeast-2_t0RnGtP1w",
    aws_user_pools_web_client_id: "5uvfqr60ke5gg9tv50r88tkb42",
    Auth: {
      identityPoolId: "ap-southeast-2:eed41b1f-640b-467a-bdd8-ac1345918c78",
      region: "ap-southeast-2",
      userPoolId: "ap-southeast-2_t0RnGtP1w",
      userPoolWebClientId: "5uvfqr60ke5gg9tv50r88tkb42",
    },
    oauth: {
      domain: "whs-safer-gamma-jp.auth.ap-southeast-2.amazoncognito.com",
      redirectSignIn: "https://gamma.jp.safer.whs.amazon.dev",
      redirectSignOut: "https://gamma.jp.safer.whs.amazon.dev",
      scope: ["openid", "profile"],
      responseType: "code",
    },
  };

  // BETA/LOCAL ONLY: the Hydra/Cypress integration test authenticates as a SAAM
  // service identity (svc-mw-...-midwaysaam) that has NO email. The identity
  // pool's authenticated role (AmazonQBusinessCognitoRole) requires an `Email`
  // session tag mapped from the token's `email` claim; with no email, the role
  // assume fails ("Invalid identity pool configuration") and Amplify emits
  // signIn_failure so the app never authenticates. The frontend does not use
  // identity-pool (IAM) credentials, so we drop the identity pool on beta/local
  // and let sign-in complete on the User Pool alone. Gamma/prod are unchanged.
  // Local/dev builds resolve gamma to "test".
  const stage = "gamma".toLowerCase();
  const skipIdentityPool = stage === "beta" || stage === "test";

  if (skipIdentityPool) {
    delete (config as { aws_cognito_identity_pool_id?: string })
      .aws_cognito_identity_pool_id;
    delete (config.Auth as { identityPoolId?: string }).identityPoolId;
  }

  Auth.configure(config);
}
